import * as React from "react";
import styled from "styled-components";
import capitalize from "lodash/capitalize";
import { Alert } from "components/bootstrap";
const Container = styled(Alert)`
  margin-top: 20px;
  max-height: 240px;
  overflow: auto;
`;
const List = styled.ul`
  list-style: initial;
  padding-left: 20px;

  ul {
    list-style: circle;
  }
`;
const ValidationError = ({ validationResult, availableGrantees }) => {
  const pastOwners = validationResult.errorContext.selectedGranteeCapabilities.map(
    (grn) => availableGrantees.find((grantee) => grantee.id === grn)
  );
  return /* @__PURE__ */ React.createElement(Container, { bsStyle: "danger" }, /* @__PURE__ */ React.createElement(List, null, /* @__PURE__ */ React.createElement("li", null, "Removing the following owners will leave the entity ownerless: ", /* @__PURE__ */ React.createElement("br", null), pastOwners.map((owner, key) => /* @__PURE__ */ React.createElement("span", { key: owner == null ? void 0 : owner.id }, capitalize(owner == null ? void 0 : owner.type), " ", /* @__PURE__ */ React.createElement("i", null, owner == null ? void 0 : owner.title), key !== pastOwners.size - 1 && ", ")).toArray())));
};
export default ValidationError;
